import { useRequest } from 'ahooks';
import Decimal from 'decimal.js';
import { atom, useAtomValue, useSetAtom } from 'jotai';

import { getFetchMailList, readMail } from '@/api/mail';
import { ACCESS_USERID_KEY } from '@/constant/config';
import Storage from '@/utils/Storage';
import { toFixed } from '@/utils/utils';

import { emitterAtom } from './emitter';
import { userStateAtom } from './user';

/**
 * 用户邮箱数据
 */

export const mailDataAtom = atom<Record<string, any>[]>([]);

export const useMailStore = () => {
  const emitter = useAtomValue(emitterAtom);
  const setMailData = useSetAtom(mailDataAtom);
  const userState = useAtomValue(userStateAtom);
  const { run: getMail } = useRequest(async () => (!userState?.isLogin ? null : getFetchMailList()), {
    manual: true,
    onSuccess: res => {
      if (!res) return;
      const record = {};
      const newList: any[] = [];
      res.fetch_rids?.forEach(item => {
        if (!record[item.rid]) {
          record[item.rid] = true;
          newList.push(item);
        }
      });

      res.open_rids?.forEach(item => {
        if (!record[item.rid]) {
          record[item.rid] = true;
          newList.push(item);
        }
      });

      const newAwards = newList
        .map(item => {
          return {
            ...item,
            awardinfo: toFixed(parseFloat(item.awardinfo) || 0, 2, Decimal.ROUND_HALF_UP)
          };
        })
        ?.sort((a, b) => b.rid - a.rid)
        ?.slice(0, 2);
      setMailData(newAwards);
    }
  });
  const saveReadState = async () => {
    //把之前本地存的已读数据发到服务端
    const userId = Storage.getAccess(ACCESS_USERID_KEY);
    const cacheRids = Storage.get(`cache-mail-rids-${userId}`, []) || [];
    if (cacheRids.length > 0) {
      await readMail({ p_rid: cacheRids });
      Storage.set(`cache-mail-rids-${userId}`, []);
    }
  };
  emitter.useSubscription(({ type }) => {
    if (type === 'refresh-mails-readstate') {
      getMail();
    }
  });

  return [getMail, saveReadState];
};
